import is from '@sindresorhus/is';

import type { JobArchitectureGenerationInfo } from '~/shared/data-contract/job-architecture';

export const useIsGenerating = (generationInfo: JobArchitectureGenerationInfo | undefined): boolean => {
    if (is.undefined(generationInfo)) {
        return false;
    }

    return !(
        generationInfo.translationState === 'finished' ||
        generationInfo.translationState === 'failed' ||
        is.undefined(generationInfo) ||
        is.undefined(generationInfo.translationState)
    );
};

export const useIsGeneratingTranslations = (generationInfo: JobArchitectureGenerationInfo | undefined): boolean => {
    const isGeneratingFromTranslationState = useIsGenerating(generationInfo);
    // The backend currently does not return translation that are processed in
    // translationState correctly thus we default to inProgress for now.
    const isGeneratingFromInProgress = generationInfo?.inProgress ?? false;

    return isGeneratingFromTranslationState || isGeneratingFromInProgress;
};

export const useIsGeneratingSkills = (generationInfo: JobArchitectureGenerationInfo | undefined): boolean => {
    return generationInfo?.skillDetectionState === 'queued' || generationInfo?.skillDetectionState === 'started';
};
